module.exports = __webpack_public_path__ + "img/kak-img.2650a890.png";